import { render, staticRenderFns } from "./MagazzinoArticoliListComponent.vue?vue&type=template&id=6c81b45d&scoped=true"
import script from "./MagazzinoArticoliListComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoArticoliListComponent.vue?vue&type=script&lang=js"
import style0 from "./MagazzinoArticoliListComponent.vue?vue&type=style&index=0&id=6c81b45d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c81b45d",
  null
  
)

export default component.exports